import React, { useState, useEffect } from "react";
import {loadStripe} from '@stripe/stripe-js';
import { useDispatch, useSelector } from "react-redux";
import { createCheckoutSessionThunk } from "../store/stripe";
import { Elements } from "@stripe/react-stripe-js";
import CheckoutForm from "./StripeCheckoutForm";

// const stripePromise = loadStripe("pk_test_51N1jsSIzDtG53Sp0X5LEbfj3PLSnsTabqURdXKBEbHqHbr4gG48TacEO4aFcWTd6t4BOFjv2uQaJDjUVpijOjns700cXVFzGvo", { 
//     stripeAccount:'acct_1R1sVsEZS34Z079z' 
//   });

const stripePromise = loadStripe("pk_live_51N1jsSIzDtG53Sp0IYroac8Yq8aSbX7PQgISERDGaQNviBMnz4SGJ4RhjZws64QrELl0aJoWqtyYe5W3Ud6bqhmV00sR5crhK1", { 
  // stripeAccount: 'acct_1QKoBWBSuxoYRObK'
});

const CheckoutApp = ({tip, restaurantId, name, phone, cartItems, coupon, address, delivery_distance_fee_, freeItem}) => {
  const dispatch = useDispatch();
  const clientSecret = useSelector((state) => state?.stripe?.data?.clientSecret);
  
  useEffect(() => {
    dispatch(createCheckoutSessionThunk(tip, restaurantId, cartItems, coupon, address, delivery_distance_fee_, name, phone, freeItem))

  }, [dispatch]);

  const appearance = {
    theme: 'flat',
  };
  const options = {
    clientSecret,
    appearance,
  };


  return (
    <div >
      {clientSecret && (
        <Elements options={options} stripe={stripePromise}>
          <CheckoutForm />
          </Elements>
      )}
    </div>
  );
}

export default CheckoutApp;
